// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v2.users.RentalManagerZillowAccountDetailsV2WebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { ZillowAccountDetailsWebApiDto } from '../..';

export const RentalManagerZillowAccountDetailsV2WebApiHandler_getZillowAccountDetails_Path =
  '/api/web/v2/users/getZillowAccountDetails';

/**
 * Get Zillow account details for the logged-in user
 */
export const RentalManagerZillowAccountDetailsV2WebApiHandler_getZillowAccountDetails = (client = getClient()) => {
  return httpFrontEndRequest<never, never, ZillowAccountDetailsWebApiDto>(
    {
      endpoint: RentalManagerZillowAccountDetailsV2WebApiHandler_getZillowAccountDetails_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};
